import React from 'react'

const Metadata = () => {
  return (
    <>
      <meta httpEquiv="X-UA-Compatible" content="IE=edge,chrome=1"></meta>
      <meta charSet="utf-8"></meta>
      <meta
        name="robots"
        content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"
      />
      <meta name="analytics" content="G-HRLKW6S3X0" />
      <meta
        name="csrf-token"
        content="Hl4U5KjkBFkHN2m2ptOE1L8QbTGV19yrEINaOrsd"
      />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, shrink-to-fit=no"
      />
      <meta property="og:type" content="website" />
      <meta name="author" content="SAPP Academy" />
      <meta
        property="og:title"
        content="Hệ thống Quản lý học và thi ACCA, CFA, CMA trực tuyến SAPP Academy"
        key="title"
      />
      <meta
        name="description"
        content="Hệ thống Nền tảng Học và Thi trực tuyến được SAPP Academy xây dựng nhằm mục đích cung cấp trải nghiệm học tập hiện đại, cá nhân hóa, giúp học viên tối ưu kết quả học tập ACCA, CFA, CMA"
        key="desc"
      />
      <meta
        name="og:description"
        content="Hệ thống Nền tảng Học và Thi trực tuyến được SAPP Academy xây dựng nhằm mục đích cung cấp trải nghiệm học tập hiện đại, cá nhân hóa, giúp học viên tối ưu kết quả học tập ACCA, CFA, CMA"
        key="description"
      />
      <meta
        property="og:image"
        content="https://sapp-lms-fe-prod.vercel.app/thumbnail.webp"
        key="image"
      />
      <meta name="og:url" content={'https://lms-pro.sapp.edu.vn'} />
      <meta
        name="keywords"
        content="sapp, lms, acca, ACCA, CFA, CMA, Big4, 3P, SAPP Academy"
      />
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content="Hệ thống Quản lý học và thi ACCA, CFA, CMA trực tuyến SAPP Academy"
      />
      <meta
        name="twitter:description"
        content="Hệ thống Nền tảng Học và Thi trực tuyến được SAPP Academy xây dựng nhằm mục đích cung cấp trải nghiệm học tập hiện đại, cá nhân hóa, giúp học viên tối ưu kết quả học tập ACCA, CFA, CMA"
      />
      <meta
        name="twitter:image"
        content="https://sapp-lms-fe-prod.vercel.app/thumbnail.webp"
      />
    </>
  )
}

export default Metadata
